import type { Router } from 'vue-router'
import type { IRouteContext } from '@shared/types/route-context'
import { middlewarePipeline } from '@shared/utils/middleware-pipeline'

import type { EUserRole } from '@shared/api/user-management/resources/user/constants/user-roles'

const middlewareGuard = (router: Router) => {
  router.beforeEach((to, from, next) => {
    /** Navigate to next if middleware is not applied */
    if (!to.meta.middleware) {
      return next()
    }

    const middleware = to.meta.middleware as Array<
      ({ to, from, next }: IRouteContext, middlewareRoleList?: EUserRole[]) => void
    >
    const context: IRouteContext = {
      to,
      from,
      next,
    }

    return middleware[0](
      {
        ...context,
        next: middlewarePipeline({ context, middleware, index: 1 }),
      },
      to.meta.middlewareRoleList as EUserRole[]
    )
  })
}

export default middlewareGuard
